import { useState } from "react";
import { Menu, X, LogOut } from "lucide-react";
import logoSigte from "./assets/sigte-logo.png";

// Bloque 2 del rediseno: sidebar fijo desde md: (igual a sigte-prototipo.jsx:2352-2384,
// mismo estado activo/inactivo de sus botones de nav), pero con una desviacion
// deliberada por debajo de md: el prototipo deja el <aside> fijo siempre visible
// (w-16 solo-iconos -> w-56 con labels); aqui en su lugar el sidebar se oculta
// del todo y aparece como drawer via hamburguesa, para no robarle ancho fijo a
// un tecnico llenando el formulario de Inspeccion desde el celular en campo.
// Compartido por SigteApp.js y SigtePlatformApp.js para no duplicar esta logica.
export function SigteSidebarLayout(p) {
  var [mobileOpen, setMobileOpen] = useState(false);

  function nav(id) {
    p.onNavigate(id);
    setMobileOpen(false);
  }

  function renderNav() {
    return (
      <nav className="flex flex-1 flex-col gap-1">
        {p.navItems.map(function (n) {
          var Icono = n.icon;
          var activa = p.activeId === n.id;
          return (
            <button key={n.id} onClick={function () { nav(n.id); }}
              className={"flex items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm font-medium transition-colors " +
                (activa ? "bg-neutral-100 text-neutral-900" : "text-neutral-500 hover:bg-neutral-50 hover:text-neutral-900")}>
              <Icono size={18} strokeWidth={activa ? 2.2 : 1.8} className="shrink-0"/>
              <span>{n.label}</span>
            </button>
          );
        })}
      </nav>
    );
  }

  function renderSessionBlock() {
    return (
      <div className="mt-4 border-t border-neutral-200 pt-4">
        <p className="truncate px-1 text-sm font-medium text-neutral-900">{p.sessionTitle}</p>
        {p.sessionSubtitle ? <p className="truncate px-1 text-xs text-neutral-400">{p.sessionSubtitle}</p> : null}
        <button onClick={p.onLogout}
          className="mt-2 flex w-full items-center gap-2 rounded-xl px-3 py-2 text-sm font-medium text-neutral-500 transition-colors hover:bg-red-50 hover:text-red-600">
          <LogOut size={16} className="shrink-0"/>
          <span>Cerrar sesión</span>
        </button>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-neutral-50">
      {/* Barra superior movil */}
      <div className="fixed inset-x-0 top-0 z-20 flex items-center justify-between border-b border-neutral-200 bg-white px-4 py-3 md:hidden">
        <img src={logoSigte} alt="SIGTE" className="h-8 w-auto" style={{aspectRatio:"1942/809"}}/>
        <button onClick={function () { setMobileOpen(true); }} aria-label="Abrir menú"
          className="rounded-lg p-2 text-neutral-500 hover:bg-neutral-100">
          <Menu size={22}/>
        </button>
      </div>

      {/* Drawer movil */}
      {mobileOpen ? (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="absolute inset-0 bg-black/30" onClick={function () { setMobileOpen(false); }}/>
          <aside className="relative z-50 flex h-full w-72 max-w-[80%] flex-col border-r border-neutral-200 bg-white px-4 py-5">
            <div className="mb-6 flex items-center justify-between">
              <img src={logoSigte} alt="SIGTE" className="h-9 w-auto" style={{aspectRatio:"1942/809"}}/>
              <button onClick={function () { setMobileOpen(false); }} aria-label="Cerrar menú"
                className="rounded-lg p-1.5 text-neutral-400 hover:bg-neutral-100">
                <X size={20}/>
              </button>
            </div>
            {renderNav()}
            {renderSessionBlock()}
          </aside>
        </div>
      ) : null}

      {/* Sidebar de escritorio */}
      <aside className="hidden md:fixed md:inset-y-0 md:left-0 md:z-10 md:flex md:w-56 md:flex-col md:border-r md:border-neutral-200 md:bg-white md:px-4 md:py-5">
        <div className="mb-6">
          <img src={logoSigte} alt="SIGTE" className="h-9 w-auto" style={{aspectRatio:"1942/809"}}/>
        </div>
        {renderNav()}
        {renderSessionBlock()}
      </aside>

      {/* Contenido */}
      <main className="flex-1 px-5 pb-8 pt-20 md:ml-56 md:px-10 md:pt-8">
        <div className="mx-auto max-w-5xl">
          {p.children}
        </div>
      </main>
    </div>
  );
}
